var aosTimer, resizeDelay;

document.addEventListener("turbolinks:before-visit", function() {
    Turbolinks.clearCache();
});

jQuery(window).on('resize', function () {

    clearTimeout(resizeDelay);
    resizeDelay = setTimeout(function() {

        if(window.matchMedia('(min-width: 992px)').matches) {
            // Header - Menu - Show desktop submenu
            jQuery('.navigation').on('mouseenter', 'li.level-0', function () {
                var thisElement = jQuery(this);
                if(thisElement.find('.navigation-helper').children().length) {
                    thisElement.children('.navigation-helper').stop().fadeIn(300);
                }
            });
            // Header - Menu - Hide desktop submenu
            jQuery('.navigation').on('mouseleave', 'li.level-0', function () {
                jQuery(this).children('.navigation-helper').stop().fadeOut(300);
            });
            // Header - Submenu - Show desktop submenu extra info
            jQuery('.navigation').on('mouseenter', 'li.level-1 a', function () {
                jQuery(this).parent().children('.navigation-extra-info').stop().animate({ 'opacity':1 }, 150);
            });
            // Header - Submenu - Hide desktop submenu extra info
            jQuery('.navigation').on('mouseleave', 'li.level-1 a', function () {
                jQuery(this).parent().children('.navigation-extra-info').stop().animate({ 'opacity':0 }, 150);
            });
        }
    
        if(window.matchMedia('(max-width: 991px)').matches) {
            // Header - Menu - Toggle mobile menu
            jQuery('header').on('click', '.menu-toggle', function () {
                if(jQuery(this).parents('header').hasClass('menu-toggled')) {
                    jQuery('body').removeClass('noscroll');
                    jQuery('header').removeClass('menu-toggled');
                } else {
                    jQuery('body').addClass('noscroll');
                    jQuery('header').addClass('menu-toggled');
                }
            });
        }

    }, 100);
    
});

jQuery(document).on('ready', function () {

    // -----------------------------------
    // User Agent
    function classSafeName(text) {
        return text.replace(/\s+/g, '-').replace(/[^a-zA-Z-]/g, '').toLowerCase();
    }
    var uaParser = new UAParser();
    var uaParserBrowser = uaParser.getBrowser();
    jQuery('body').addClass('ua-'+classSafeName(uaParserBrowser.name));
    var uaParserDevice = uaParser.getDevice();
    if( uaParserDevice.type !== undefined ) {
        jQuery('body').addClass('ua-'+classSafeName(uaParserDevice.type));
    }
    var uaParserOS = uaParser.getOS();
    jQuery('body').addClass('ua-'+classSafeName(uaParserOS.name));
    if( window.location.hash == '#ua' ) {
        var deviceType = '';
        if( uaParserDevice.type !== undefined ) {
            deviceType = "\nDevice: "+uaParserDevice.type+" - ua-"+classSafeName(uaParserDevice.type);
        }
        alert("Browser: "+uaParserBrowser.name+" - ua-"+classSafeName(uaParserBrowser.name)+"\nOS: "+uaParserOS.name+" - ua-"+classSafeName(uaParserOS.name)+deviceType);
    }
    // -----------------------------------

    if(window.matchMedia('(min-width: 992px)').matches) {
        // Header - Menu - Show desktop submenu
        jQuery('.navigation').on('mouseenter', 'li.level-0', function () {
            var thisElement = jQuery(this);
            if(thisElement.find('.navigation-helper').children().length) {
                thisElement.children('.navigation-helper').stop().fadeIn(300);
            }
            var longestMenuItem = 0;
            jQuery( "header .menu-container .navigation .menu li.level-1 a" ).each(function() {
                if( longestMenuItem < jQuery(this).width() ) {
                    longestMenuItem = jQuery(this).width();
                }
            });
            longestMenuItem = longestMenuItem + 98;
            jQuery( "header .menu-container .navigation .menu li.level-1 .navigation-extra-info" ).css('left', longestMenuItem+'px');
        });
        // Header - Menu - Hide desktop submenu
        jQuery('.navigation').on('mouseleave', 'li.level-0', function () {
            jQuery(this).children('.navigation-helper').stop().fadeOut(300);
        });
        // Header - Submenu - Show desktop submenu extra info
        jQuery('.navigation').on('mouseenter', 'li.level-1 a', function () {
            jQuery(this).parent().children('.navigation-extra-info').stop().animate({ 'opacity':1 }, 150);
        });
        // Header - Submenu - Hide desktop submenu extra info
        jQuery('.navigation').on('mouseleave', 'li.level-1 a', function () {
            jQuery(this).parent().children('.navigation-extra-info').stop().animate({ 'opacity':0 }, 150);
        });
    }

    // Header - Menu - Toggle mobile menu
    jQuery('header').on('click', '.menu-toggle', function () {
        if(jQuery(this).parents('header').hasClass('menu-toggled')) {
            jQuery('body').removeClass('noscroll');
            jQuery('header').removeClass('menu-toggled');
        } else {
            jQuery('body').addClass('noscroll');
            jQuery('header').addClass('menu-toggled');
        }
    });

    // Add Mac class (for font touch-ups)
	if (/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)) {
		jQuery('body').addClass("mac");
	}

    // Header - Menu - Remove junk
    jQuery('header .menu .navigation-helper .wrapper:empty').remove();

    // Footer - Jump to first section
    jQuery("body").on('click', 'footer .jump-first-section', function() {
        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery("html, body").offset().top
        }, 600);
    });

    // AOS
    setTimeout(function() {
        AOS.init({
            disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
            startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
            initClassName: 'aos-init', // class applied after initialization
            duration: 500,
            offset: 50,
            anchorPlacement: 'top-bottom',
            once: true
        });
    }, 100);
    
    // AOS bugs with Tiny on the same page => not working on content after the slider
    jQuery(window).on("scroll", function () {
        clearInterval(aosTimer);
        aosTimer = setTimeout(function() {
            AOS.init();
        }, 100)
    });

    // Tooltipster
    jQuery('.tooltip').tooltipster({
        delay: 150,
        animationDuration: 300
    });

    // Tooltipster - white theme
    jQuery('.tooltip-white').tooltipster({
        delay: 150,
        animationDuration: 300,
        theme: 'tooltipster-white'
    });

    // Flatpickr
    jQuery(".datepicker").flatpickr({
        minDate: "today",
        dateFormat: "m-d-Y",
        onChange: function(selectedDates, dateStr, instance) {
            // Bugfix custom validation
            jQuery('.estimates.estimates-form input[name=date]').blur();
        }
    });

    // Highlight current menu item
    var currentMenuItem = window.location.pathname;
        currentMenuItem = currentMenuItem.replace(/^\/|\/$/g, '');
        currentMenuItem = currentMenuItem.split('/');
        currentMenuItem = currentMenuItem[0];
    if(currentMenuItem != '') {
        jQuery( "header .menu-container .navigation .menu > li > a" ).each(function() {
            var menuItem = jQuery(this);
            var menuItemHref = menuItem.attr('href');
            if( menuItemHref.indexOf(currentMenuItem) >= 0 ) {
                menuItem.addClass('active');
            }
        });
    }

});

// Scroll to element
function scrollToElement(element=false, position=false, offset=0) {
    var elementPosition;
    // Scroll to top
    if( element && element == 'top') {
        elementPosition = 0;
    }
    // Scroll to bottom
    if( element && element == 'bottom') {
        elementPosition = jQuery(document).height();
    }
    // Scroll to specific element
    if( element && jQuery.inArray(element, ['top', 'bottom']) == -1) {
        if( jQuery(element).length ) {
            elementPosition = jQuery(element).offset().top;
        } else {
            console.log('Scroll to element | "'+element+'" does not exist.');
            return false;
        }
    }
    // Scroll to position
    if( !element && position ) {
        elementPosition = position;
    }
    // Offset
    if( offset != 0 ) {
        elementPosition = elementPosition+offset;
    }
    // Include sticky header height into final calculations
    elementPosition = elementPosition - jQuery('header').outerHeight();
    // Scroll to element position
    jQuery([document.documentElement, document.body]).animate({
        scrollTop: elementPosition
    }, 600);
}
